import { ThemePreset } from "../components/branding/theme/themeType";

export const themePresets: ThemePreset[] = [
  {
    id: 'default',
    name: 'Default Theme',
    colors: {
      primary: '#007bff',
      primaryText: '#ffffff',
      secondary: '#bfc7cd',
      secondaryText: '#ffffff',
      background: '#ffffff',
      text: '#000000',
      buttonText: '#ffffff',
      sidebarBackground: '#f3f4f6',
      surface: '#ffffff',
    },
  },
  {
    id: 'dark',
    name: 'Dark Theme',
    colors: {
      primary: '#1f6feb',
      primaryText: '#ffffff',
      secondary: '#30363d',
      secondaryText: '#ffffff',
      background: '#222222',
      sidebarBackground: '#161b22',
      surface: '#545454',
      text: '#f0f6fc',
      buttonText: '#ffffff',
    }
  },
  {
    id: 'pastel',
    name: 'Pastel Theme',
    colors: {
      primary: '#a3d2ca',
      primaryText: '#000000',
      secondary: '#5eaaa8',
      secondaryText: '#000000',
      background: '#f8f1f1',
      text: '#000000',
      buttonText: '#ffffff',
      sidebarBackground: '#f1f5f5',
      surface: '#ffffff',
    },
  }
];